// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import masterDataApi from '~/apis/masterData';
import { IBodyCreateMasterData, IFormUpdateMasterData, IQueryMasterData } from '~/utils/interface/masterData';
import {
  CREATE_MASTER_DATA,
  DELETE_MASTER_DATA,
  GET_ACTIVITY_MASTER_DATA,
  GET_DETAIL_MASTER_DATA,
  UPDATE_MASTER_DATA,
} from '~/utils/constants/actionType';
import { IBodyUpdate } from '~/utils/interface/common';

export const getListMasterData = createAsyncThunk(
  GET_ACTIVITY_MASTER_DATA,
  async (params: IQueryMasterData, { rejectWithValue }) => {
    try {
      const resp = await masterDataApi.getListMasterData(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDetailMasterData = createAsyncThunk(GET_DETAIL_MASTER_DATA, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await masterDataApi.getDetailMasterData(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createMasterData = createAsyncThunk(
  CREATE_MASTER_DATA,
  async (body: IBodyCreateMasterData, { rejectWithValue }) => {
    try {
      const resp = await masterDataApi.createMasterData(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateMasterData = createAsyncThunk(
  UPDATE_MASTER_DATA,
  async (params: IBodyUpdate<IFormUpdateMasterData>, { rejectWithValue }) => {
    try {
      const resp = await masterDataApi.updateMasterData(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteMasterData = createAsyncThunk(DELETE_MASTER_DATA, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await masterDataApi.deleteMasterData(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
